var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRewardOne(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 62,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_434_159)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.2446 5.30294L15.4069 4.20346L14.9929 2.48959C14.8091 1.72948 14.105 1.22274 13.3331 1.28349L11.2304 1.44623L10.0259 0.379727C9.43261 -0.126488 8.56949 -0.126488 7.97419 0.3792L6.76963 1.44619L4.66693 1.28345C3.90372 1.22991 3.19047 1.72994 3.02619 2.42723C2.99219 2.53291 2.37812 4.44172 2.41799 4.31772L0.755728 5.30238C0.0898688 5.71128 -0.176897 6.53214 0.121263 7.25418L0.838627 8.99276L0.121791 10.7309C-0.176897 11.4534 0.090361 12.2738 0.755728 12.6821L2.59152 13.7739L3.0071 15.4955C3.18991 16.2551 3.89082 16.7593 4.6669 16.7016L6.74692 16.5409L7.97412 17.62C8.27129 17.8733 8.6354 18 9.00001 18C9.36409 18 9.72873 17.8733 10.0259 17.6199L11.2531 16.5409L13.3331 16.7016C14.119 16.7639 14.8101 16.2556 14.9929 15.4955L15.4069 13.7816L17.2446 12.6821C17.9094 12.2738 18.1762 11.4534 17.8785 10.7309L17.1611 8.9928L17.879 7.25369C18.1767 6.53221 17.9099 5.71131 17.2446 5.30294ZM9.00001 14.8008C5.80146 14.8008 3.19923 12.1986 3.19923 9C3.19923 5.80145 5.80146 3.19922 9.00001 3.19922C12.1986 3.19922 14.8008 5.80145 14.8008 9C14.8008 12.1986 12.1986 14.8008 9.00001 14.8008Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 4.25391C6.38286 4.25391 4.25391 6.38286 4.25391 9C4.25391 11.6171 6.38286 13.7461 9 13.7461C11.6171 13.7461 13.7461 11.6171 13.7461 9C13.7461 6.38286 11.6171 4.25391 9 4.25391ZM12.0096 7.7908L8.84549 10.9549C8.74248 11.0579 8.60755 11.1094 8.47266 11.1094C8.33776 11.1094 8.2028 11.0579 8.09982 10.9549L5.99045 8.84549C5.78447 8.63951 5.78447 8.30577 5.99045 8.09979C6.19643 7.89381 6.53017 7.89381 6.73615 8.09979L8.47266 9.83633L11.2639 7.0451C11.4699 6.83912 11.8036 6.83912 12.0096 7.0451C12.2156 7.25108 12.2156 7.58482 12.0096 7.7908Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_434_159"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "currentColor"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRewardOne);
export default __webpack_public_path__ + "static/media/rewardOne.07cf5f68bf08bc4ac63f810fc792a573.svg";
export { ForwardRef as ReactComponent };